/* eslint-disable import/prefer-default-export */

import { FeatureFlagsType } from '../../client/index.helper';

export type FastlaneInitialState = Omit<typeof window.__INITIAL_STATE__, 'gateway' | 'user' | 'authn'> & {
  authnApi: string;
  featureFlags: FeatureFlagsType;
  gatewayApi: string;
  overrideMocks?: Record<string, boolean>;
}

// This is a terrible idea, but it isolates the fastlane variables,
// so we know exactly what we need in the future and can ditch what we don't
// and don't have to unpick everything and can tidy up and replace at will...
// "Act In Haste, Repent At Leisure"
export const fastlaneFormatIntState = (initialState: typeof window.__INITIAL_STATE__): FastlaneInitialState => {
  const {
    affiliate,
    appClipUrl,
    appName,
    appVersion,
    authn: authnApi,
    brandData,
    customerVehicleLimit,
    experimentDecisions,
    featureFlags,
    gateway: gatewayApi,
    guideData,
    guidesPreviewData,
    hideAnnouncement,
    isNewDesign,
    landingPageData,
    optimizelySdk,
    photosAppUrl,
    photoUploader,
    providersVersions,
    recentSales,
    reviewsApi,
    reviewsData,
    sitemapData,
    statSigKey,
    wordpressApi,
    wordpressData,
    youtubeEmbedURL,
  } = initialState;

  return {
    affiliate,
    appClipUrl,
    appName,
    appVersion,
    authnApi,
    brandData,
    customerVehicleLimit,
    experimentDecisions,
    featureFlags,
    gatewayApi,
    guideData,
    guidesPreviewData,
    hideAnnouncement,
    isNewDesign,
    landingPageData,
    optimizelySdk,
    photosAppUrl,
    photoUploader,
    providersVersions,
    recentSales,
    reviewsApi,
    reviewsData,
    sitemapData,
    statSigKey,
    wordpressApi,
    wordpressData,
    youtubeEmbedURL,
  };
};
